// Action Types
export const SET_MATCHED_PROTOCOLS = 'SET_MATCHED_PROTOCOLS';

// Action Creators
export const setMatchedProtocols = (protocols) => ({
  type: SET_MATCHED_PROTOCOLS,
  payload: protocols,
});
